import script from "./ErrorMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&setup=true&lang=js"

import "./ErrorMessages.vue?vue&type=style&index=0&id=fdabde82&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdabde82"]])

export default __exports__